import { MdLock as LockIcon } from "react-icons/md";
import { PaypalLogo, StripeLogo } from "../../../../Atoms/PaymentLogos";
import styles from "./SecurePaymentsFooter.module.css";

export default function SecurePaymentsFooter() {
  return (
    <div className={styles.SecurePaymentsFooter}>
      <div
        style={{
          marginBottom: 8,
          fontSize: 13,
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        <LockIcon style={{ fontSize: 14 }} />
        <span>Secure payments with</span>
      </div>
      <div>
        <span
          style={{
            margin: "0 4px",
          }}
        >
          <StripeLogo height={16} />
        </span>
        <span
          style={{
            margin: "0 4px",
          }}
        >
          <PaypalLogo height={16} />
        </span>
      </div>
    </div>
  );
}
